import { HospiceClient } from "../common/hospice-client";
import { autoinject } from "aurelia-framework";
import {
    IAxxessIntelligenceSearchRequest,
    IAxxessIntelligenceSearchResponseBase,
    IAxxessIntelligenceUserTracker,
    IFeedbackResult,
    IInternalSummarizationRequest,
    IExternalSummarizationRequest,
    ISummarizationResponse,
    IIsAxxessFeatureLocked,
    IIsPremiumUser,
    ISummarizationStatus
} from "../interfaces/i-axxess-intelligence";

@autoinject()
export class AiService {
    private _httpClient: HospiceClient;
    private _baseUrl: string = "/api/v1/ask-axxess";
    private _baseUrlNew: string = "/api/v1/accounts";

    public constructor(httpClient: HospiceClient) {
        this._httpClient = httpClient;
    }

    public async getSearchInfo(query: IAxxessIntelligenceSearchRequest) {
        return await this._httpClient
            .build(`${this._baseUrl}/search`)
            .useQueryString(query)
            .fetch<IAxxessIntelligenceSearchResponseBase>();
    }

    public async feedbackResult(params: IFeedbackResult) {
        return await this._httpClient.build(`${this._baseUrl}/feedback`).useMethod("POST").useBody(params).fetch();
    }

    public async trackUserActions(params: IAxxessIntelligenceUserTracker) {
        return await this._httpClient
            .build(`${this._baseUrl}/track-user-action`)
            .useMethod("POST")
            .useBody(params)
            .fetch();
    }

    public async startSummarizationsResponse(requestTrackingId: string) {
        return await this._httpClient
            .build(`${this._baseUrl}/summarizations/${requestTrackingId}/status`)
            .fetch<ISummarizationResponse>();
    }

    public async summarizeInternalDocument(params: IInternalSummarizationRequest) {
        return await this._httpClient
            .build(`${this._baseUrl}/summarize-internal`)
            .useMethod("POST")
            .useBody(params)
            .fetch<ISummarizationStatus>();
    }

    public async summarizeExternalDocument(params: IExternalSummarizationRequest) {
        return await this._httpClient
            .build(`${this._baseUrl}/summarize-external`)
            .useMethod("POST")
            .useBody(params)
            .fetch<ISummarizationStatus>();
    }

    public async isPremiumAiUser(accountId: string) {
        return await this._httpClient
            .build(`${this._baseUrlNew}/${accountId}/axxess-intelligence-status`)
            .fetch<IIsPremiumUser>();
    }

    public async isAxxessFeatureLocked() {
        return await this._httpClient.build(`${this._baseUrl}/within-usage-limit`).fetch<IIsAxxessFeatureLocked>();
    }
}
